/**
 * Returns a promise for the enrollment data object from the enrollment API.
 */
import Q from 'q';

import { tupleToStringKey } from 'js/lib/stringKeyTuple';

import membershipsAPI from 'pages/open-course/common/membershipApi';

export default function (userId: $TSFixMe, courseId: $TSFixMe) {
  return Q(membershipsAPI.get(tupleToStringKey([userId, courseId])));
}
